module.exports = __webpack_public_path__ + "static/media/my-photo-compress.8506426a.webp";